import {IStateStore}         from '../../ap-interface';
import {Injectable}          from '@angular/core';
import {Store}               from '../index';
import {SafeBehaviorSubject} from 'ts-tooling';
import {ApSignalrService}    from '../../ap-core/services/ap-signalr.service';
import ISensorFieldData = Data.Sensor.ISensorFieldData;
import IGuid = System.IGuid;
import {
  NetTypes,
  SensorFieldDataLoad,
  SensorFieldDataLoadSuccess,
  SensorRasterValuesLoad, SensorRasterValuesLoadFail,
  SensorRasterValuesLoadSuccess
} from '@backend';

interface INFertilizationStore extends IStateStore<ISensorFieldData> {
  sensorRasterValues: number[][];
  sensorRasterValuesLoaded: boolean;
  sensorRasterValuesLoading: boolean;
}

@Injectable({providedIn: 'root'})
export class SensorStore extends Store<INFertilizationStore> {
  constructor(public backend: ApSignalrService) {
    super(backend, {
      data: [],
      loaded: false,
      loading: false,
      sensorRasterValues: [],
      sensorRasterValuesLoaded: false,
      sensorRasterValuesLoading: false
    });

    backend.registerObservable(SensorFieldDataLoadSuccess).subscribe(d => {
      this.SetLoadFinishState();
      super.Mutate(s => s.data, () => d.Data);
    });

    backend.registerObservable(SensorRasterValuesLoadSuccess).subscribe(d => {
      super.Mutate(s => s.sensorRasterValuesLoading, () => false);
      super.Mutate(s => s.sensorRasterValuesLoaded, () => true);
      let result: number[][] = [];
      if (d.Data) {
        result = JSON.parse(d.Data);
      }
      super.Mutate(s => s.sensorRasterValues, () => result);
    });

    backend.registerObservable(SensorRasterValuesLoadFail).subscribe(() => {
      super.Mutate(s => s.sensorRasterValuesLoading, () => false);
      super.Mutate(s => s.sensorRasterValuesLoaded, () => false);
    });
  }

  public get Loading$(): SafeBehaviorSubject<boolean> {
    return super.Listen(s => s.loading);
  }

  public get SensorFieldData$(): SafeBehaviorSubject<ISensorFieldData[]> {
    return super.Listen(s => s.data);
  }

  public get SensorFieldData(): ISensorFieldData[] {
    return this.SensorFieldData$.getValue();
  }

  public get SensorRasterValues$(): SafeBehaviorSubject<number[][]> {
    return super.Listen(s => s.sensorRasterValues);
  }

  public get SensorRasterValuesLoading$(): SafeBehaviorSubject<boolean> {
    return super.Listen(s => s.sensorRasterValuesLoading);
  }

  public get SensorRasterValuesLoaded$(): SafeBehaviorSubject<boolean> {
    return super.Listen(s => s.sensorRasterValuesLoaded);
  }

  public loadSensorFieldData(): void {
    this.SetLoadState();
    this.DispatchBackend(new SensorFieldDataLoad([]));
  }

  public loadSensorRasterValues(planBookIds: IGuid[]): void {
    super.Mutate(s => s.sensorRasterValues, () => []);
    super.Mutate(s => s.sensorRasterValuesLoading, () => true);
    super.Mutate(s => s.sensorRasterValuesLoaded, () => false);
    this.DispatchBackend(new SensorRasterValuesLoad([
      {Name: 'planBookIds', Type: NetTypes.GUID + '[]', Value: planBookIds}
    ]));
  }

  public getSensorFieldData(fieldGeomId: IGuid): ISensorFieldData {
    return super.Listen(s => s.data).getValue()?.Find(_ => _?.FieldGeomId === fieldGeomId) as ISensorFieldData;
  }
}
